import React, { useState, useEffect } from 'react';
import { Accordion } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import { withStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
import Select from '@material-ui/core/Select';
import Spinner from "react-bootstrap/Spinner";
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import './css/reservationResto.css';
import { AfficheReservationResto, ChangeEtat } from '../../Api/RestaurantApi/ReservationApi';

const Reservation = () => {

  const [loadData, setLoadData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dateGroup, setDateGroup] = useState([]);
  const [dateFilter, setDateFilter] = useState([]);
  const [data, setData] = useState([]);
  const [sliceValue, setSliceValue] = useState(30);

  let location = useLocation();
  const [openDropDown, setOpenDropDown] = useState(false);
  const restaurant = useSelector((state) => state.restaurant);

  const [personneFilter, setPersonneFilter] = useState([
    { id: 1, value: "1" },
    { id: 2, value: "2" },
    { id: 3, value: "3" },
    { id: 4, value: "4" },
    { id: 5, value: "5" },
    { id: 6, value: "6" },
    { id: 7, value: "7" },
    { id: 8, value: "8" },
    { id: 9, value: "9" },
    { id: 10, value: "10" },
    { id: 11, value: "11" }
  ]);

  const [promoFilter, setPromoFilter] = useState([
    { id: 1, value: "Promotion de -50%" },
    { id: 2, value: "Promotion de -40%" },
    { id: 3, value: "Promotion de -30%" },
    { id: 4, value: "Promotion de -20%" },
    { id: 5, value: "Promotion de -10%" },
  ]);

  const [presenceFilter, setPresenceFilter] = useState([
    { id: 1, value: "Deja venus" },
    { id: 2, value: "Nouveau" },
  ]);

  useEffect(() => {
    AfficheResaResto();
  }, []);

  const plural = (value) => {
    if (value < 10) {
      return "0" + value;
    } else {
      return value;
    }
  }

  const AfficheResaResto = () => {

    setLoadData(true);
    AfficheReservationResto(restaurant.id)
      .then(function (response) {
        console.log("data =>", response.data.donner);

        const dataG = [];
        const dataF = [];

        response.data.donner.forEach((element, i) => {
          const date = plural(new Date(element.createdAt).getDate()) + "/" + plural(parseInt(new Date(element.createdAt).getMonth()) + 1) + "/" + new Date(element.createdAt).getFullYear();
          let existeDateGroup = dataG.find((el) => el.dateGroupe === date);
          const existeDateFilter = dataF.find((el) => el.dateGroupe === date);
          if (existeDateGroup) {
            console.log("Le date existe", date);
          } else {
            dataG.push({ id: i + 1, dateGroupe: date, dateValue: element.createdAt, anne: element.anne, mois: element.mois, jour: element.jour });
          }
          if (existeDateFilter) {
            console.log("Le date existe", date);
          } else {
            dataF.push({ id: i + 1, dateGroupe: date, dateValue: element.createdAt, anne: element.anne, mois: element.mois, jour: element.jour });
          }

        });
        setDateGroup(dataG);
        setDateFilter(dataF);
        setData(response.data.donner);
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        setLoadData(false);
      });
  };

  console.log("Date groupe=>", dateGroup);


  const BootstrapInput = withStyles((theme) => ({
    root: {
      'label + &': {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: 'relative',
      backgroundColor: '#f1416c',
      border: '1px solid #f1416c',
      fontSize: 15,
      width: 120,
      color: 'white',
      padding: '3px 0px 3px 4px!important',
      boxShadow: '#f1416c 0px 1px 4px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      '&:focus': {
        borderRadius: 4,
        borderColor: '#f1416c',
        boxShadow: 'none',
        backgroundColor: '#f1416c',
        color: 'white',
      },
    },
  }))(InputBase);

  const handleChange = (e, id, idClient) => {
    if (!localStorage.getItem('tokenSociete')) {
      console.log("select value", e.target.value + "/" + id);
      setLoadData(true);
      const data = { idReservation: id, etat: e.target.value, idRestaurant: restaurant.id, idClient: idClient };
      ChangeEtat(data).then(function (response) {
        if (response.data.title === "success") {
          toast.success(response.data.message);
          AfficheResaResto();
        }
      }).catch(function (error) {
        console.log(error.response);
        toast.warning(error.response.data.message);
      }).finally(function () {
        setLoadData(false);
      });
    } else {
      toast.warning("Vous n'êtes pas autorisé à modifier ces éléments");
    }
  }




  const handleDrop = () => {
    setOpenDropDown(!openDropDown);
  }

  const formateTime = (value) => {
    return plural(new Date(value).getUTCHours()) + "h : " + plural(new Date(value).getMinutes());
  }
  const formateDate = (value) => {
    return plural(new Date(value).getDate()) + "/" + plural(parseInt(new Date(value).getMonth()) + 1) + "/" + new Date(value).getFullYear();
  }

  const viewDateFilter = (element) => {
    return plural(new Date(element.createdAt).getDate()) + "/" + plural(parseInt(new Date(element.createdAt).getMonth()) + 1) + "/" + new Date(element.createdAt).getFullYear();
  }

  const viewReservation = (element) => {

    const dataResa = data.filter((el) => viewDateFilter(el) === element.dateGroupe);
    console.log("La result est =>", dataResa);

    return (
      <div className='table-responsive'>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Pseudo</th>
              <th>Date de réservation</th>
              <th>Personne</th>
              <th>Etat</th>
              <th>Promo</th>
              <th>Demande Spécifique</th>
              <th>Déja venu</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {dataResa.map((item, index) => {
              return (
                <tr key={index}>
                  <td>
                    <span className='pseudo'>{item.nom} {item.prenom}</span>
                  </td>
                  <td>{formateDate(item.datePrise)} à {formateTime(item.heurePrise)}</td>
                  <td>{item.nombrePersonne} personnes</td>
                  <td><span className="status">{item.etat}</span></td>
                  {item.promo !== null ? <td>{item.promo}</td> : <td>Pas de promotion</td>}

                  {item.demandeSpecifique !== null ? <td>{item.demandeSpecifique}</td> : <td>Pas de demande</td>}

                  <td>{item.dejasVenus}</td>
                  <td><FormControl>
                    <Select
                      id="demo-customized-select"
                      onChange={(e) => handleChange(e, item.id, item.client.id)}
                      value=""
                      displayEmpty
                      placeholder="Changer l'etat"
                      renderValue={(value) => value !== "" ? value : <em>Changement Etat</em>}
                      input={<BootstrapInput />}
                    >
                      <MenuItem value="Réservé">Réservé</MenuItem>
                      <MenuItem value="Confirmé">Confirmé</MenuItem>
                      <MenuItem value="Annulé">Annulé</MenuItem>
                      <MenuItem value="No show">No show</MenuItem>
                      <MenuItem value="Arrivé">Client est arrivé</MenuItem>
                      <MenuItem value="Addition">Addition</MenuItem>
                    </Select>
                  </FormControl></td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    )
  }

  const handleFilterDate = (value) => {
    let dataDate = dateFilter.filter((el) => el.dateGroupe === value);
    setDateGroup(dataDate);
  }

  const handleReinitialiser = () => {
    AfficheResaResto();
  }

  const handlePersonne = (value) => {
    setDateGroup([]);
    if (value === 11) {
      const dataG = [];
      let dataPersonne = data.filter((el) => parseInt(el.nombrePersonne) > 10);
      console.log("Data personne =>", dataPersonne);
      dataPersonne.forEach((element, i) => {
        const date = plural(new Date(element.createdAt).getDate()) + "/" + plural(parseInt(new Date(element.createdAt).getMonth()) + 1) + "/" + new Date(element.createdAt).getFullYear();
        const existeDateGroup = dataG.find((el) => el.dateGroupe === date);
        if (existeDateGroup) {
          console.log("Le date existe", date);
        } else {
          dataG.push({ id: i + 1, dateGroupe: date, dateValue: element.createdAt, anne: element.anne, mois: element.mois, jour: element.jour });
        }
        setDateGroup(dataG);

      });
    } else {
      setDateGroup([]);
      let dataPersonne = data.filter((el) => el.nombrePersonne === value);
      console.log("Data personne =>", dataPersonne);
      const dataG = [];
      dataPersonne.forEach((element, i) => {
        const date = plural(new Date(element.createdAt).getDate()) + "/" + plural(parseInt(new Date(element.createdAt).getMonth()) + 1) + "/" + new Date(element.createdAt).getFullYear();
        const existeDateGroup = dataG.find((el) => el.dateGroupe === date);
        if (!existeDateGroup) {
          dataG.push({ id: i + 1, dateGroupe: date, dateValue: element.createdAt, anne: element.anne, mois: element.mois, jour: element.jour });
        } else {
          console.log("Le date existe", date);
        }
      });
      setDateGroup(dataG);
    }
  }

  const handlePromo = (value) => {
    setDateGroup([]);
    let dataPromo = data.filter((el) => el.promo === value);
    const dataG = [];
    dataPromo.forEach((element, i) => {
      const date = plural(new Date(element.createdAt).getDate()) + "/" + plural(parseInt(new Date(element.createdAt).getMonth()) + 1) + "/" + new Date(element.createdAt).getFullYear();
      const existeDateGroup = dataG.find((el) => el.dateGroupe === date);
      if (!existeDateGroup) {
        dataG.push({ id: i + 1, dateGroupe: date, dateValue: element.createdAt, anne: element.anne, mois: element.mois, jour: element.jour });
      } else {
        console.log("Le date existe", date);
      }
    });

    setDateGroup(dataG);
  }


  const handlePresence = (value) => {
    setDateGroup([]);
    if (value === "Deja venus") {
      let dataPresence = data.filter((el) => el.dejasVenus === "Oui");
      const dataG = [];
      dataPresence.forEach((element, i) => {
        const date = plural(new Date(element.createdAt).getDate()) + "/" + plural(parseInt(new Date(element.createdAt).getMonth()) + 1) + "/" + new Date(element.createdAt).getFullYear();
        const existeDateGroup = dataG.find((el) => el.dateGroupe === date);
        if (!existeDateGroup) {
          dataG.push({ id: i + 1, dateGroupe: date, dateValue: element.createdAt, anne: element.anne, mois: element.mois, jour: element.jour });
        } else {
          console.log("Le date existe", date);
        }
      });
      setDateGroup(dataG);
    } else {
      setDateGroup([]);
      let dataPresence = data.filter((el) => el.dejasVenus !== "Oui");
      const dataG = [];
      dataPresence.forEach((element, i) => {
        const date = plural(new Date(element.createdAt).getDate()) + "/" + plural(parseInt(new Date(element.createdAt).getMonth()) + 1) + "/" + new Date(element.createdAt).getFullYear();
        const existeDateGroup = dataG.find((el) => el.dateGroupe === date);
        if (!existeDateGroup) {
          dataG.push({ id: i + 1, dateGroupe: date, dateValue: element.createdAt, anne: element.anne, mois: element.mois, jour: element.jour });
        } else {
          console.log("Le date existe", date);
        }
      });
      setDateGroup(dataG);
    }

  }

  return (
    <div>
      <Helmet>
        <title>Réservations</title>
        <meta name='description' content='Restaurant nouvelle réservations .' />
        <link rel='canonical' href={location.pathname} />
      </Helmet>
      <div className='nouvelle_reservation'>
        <div className='container'>
          <div className='bloc_nouvelle_reservation'>
            <div className='nouvelle_reservation_titre'>
              <div className='d-flex mt-2 titre'>
                <i className='fa fa-bell-o'></i> <h1>Nouvelles réservations - Notifications</h1>
              </div>
              <div className='nouvelle_reservation_renseignement'>
                <p>Affichage des réservations prises par les clients sur les 31 jours glissants. Chaque nouvelle réservation du jour sera notifiée ici. Vous avez ensuite la possibilité d’en voir les détails en cliquant dessus.
                </p>
              </div>
              {data.length !== 0 ?
                <div className='d-flex justify-content-end'>
                  <button className='btn' onClick={handleDrop}>Trier par:</button>
                </div>
                : ""}

            </div>
            <div className='col-xs-12 col-12 col-sm-12'>
              <div className='d-flex justify-content-end'>
                <div className={openDropDown === true ? "body-filter show" : "body-filter"}>
                  <div className="filter-content">
                    <div className='dateFilter'>
                      <div className='titreFilter'>
                        <h2>Date</h2>
                      </div>
                      <div className='content_date'>
                        {dateFilter.map((el, i) => {
                          return (<span onClick={() => handleFilterDate(el.dateGroupe)} key={i}>{el.dateGroupe}</span>)
                        })}
                      </div>
                    </div>
                    <div className='personneFilter'>
                      <div className='titreFilter'>
                        <h2>Personne</h2>
                      </div>
                      <div className='content_personne'>
                        <div>
                          {personneFilter.map((el, i) => {
                            if (el.id === 11) {
                              return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" onChange={() => handlePersonne(el.value)} name="inlineRadioOptions" id={el.id} defaultValue={el.id} />
                                <label className="form-check-label" htmlFor={el.id}>+10</label>
                              </div>)
                            } else {
                              return (<div className="form-check form-check-inline" key={i}>
                                <input className="form-check-input" type="radio" onChange={() => handlePersonne(el.value)} name="inlineRadioOptions" id={el.id} defaultValue={el.id} />
                                <label className="form-check-label" htmlFor={el.id}>{el.value}</label>
                              </div>)
                            }

                          })}


                        </div>

                      </div>
                    </div>
                    <div className='promotionFilter'>
                      <div className='titreFilter'>
                        <h2>Promotion</h2>
                      </div>
                      <div className='content_personne'>
                        <div>
                          {promoFilter.map((el, i) => {
                            return (<div className="form-check form-check-inline" key={i}>
                              <input className="form-check-input" type="radio" onChange={() => handlePromo(el.value)} name="inlineRadioOptionsPromo" id={el.value} defaultValue={el.value} />
                              <label className="form-check-label" htmlFor={el.value}>{el.value}</label>
                            </div>)

                          })}


                        </div>

                      </div>
                    </div>
                    <div className='presenceFilter'>
                      <div className='titreFilter'>
                        <h2>Presence</h2>
                      </div>
                      <div className='content_personne'>
                        <div>
                          {presenceFilter.map((el, i) => {
                            return (<div className="form-check form-check-inline" key={i}>
                              <input className="form-check-input" type="radio" onChange={() => handlePresence(el.value)} name="inlineRadioOptionsPresence" id={el.value} defaultValue={el.value} />
                              <label className="form-check-label" htmlFor={el.value}>{el.value}</label>
                            </div>)

                          })}


                        </div>

                      </div>
                    </div>

                  </div>
                  <div className="footer-value">
                    <div className="action">
                      <button className="btn btn_reinitialiser btn-sm" onClick={handleReinitialiser}>
                        Reinitialiser
                      </button>
                      <button className="btn btn_fermerFilter btn-sm" onClick={() => setOpenDropDown(false)}>
                        Fermer
                      </button>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            {loadData === true ?
              <div className="d-flex justify-content-center mt-5">
                <Spinner
                  animation="border"
                  className="load"
                  variant="info"
                  size="md"
                />
              </div> :

              dateGroup.length !== 0 ?
                <div className='nouvelle_reservation_content' onClick={() => setOpenDropDown(false)}>
                  <Accordion defaultActiveKey="0" >
                    {dateGroup.slice(0, sliceValue).map((el, i) => {
                      console.log("La valeur de i est ", i);
                      if (i === 0) {
                        return (<Accordion.Item eventKey="0" key={i}>
                          <Accordion.Header>
                            <div className='d-flex'>
                              <span>Réservations prises le {el.dateGroupe}</span>
                            </div>
                          </Accordion.Header>
                          <Accordion.Body>
                            {viewReservation(el)}
                          </Accordion.Body>
                        </Accordion.Item>)
                      } else {
                        return (<Accordion.Item eventKey={i} key={i}>
                          <Accordion.Header>
                            <div className='d-flex'>
                              <span>Réservations prises le {el.dateGroupe}</span>
                            </div>
                          </Accordion.Header>
                          <Accordion.Body>
                            {viewReservation(el)}
                          </Accordion.Body>
                        </Accordion.Item>)
                      }


                    })}
                  </Accordion>
                  {dateGroup.length > 30 ?
                    <div className='d-flex justify-content-center'>
                      <button className='btn btn_autre' onClick={() => setSliceValue(sliceValue + 30)} >Accèder à l'historique</button>
                    </div>
                    : ""}

                </div>
                : <p>Reservation vide ...</p>

            }

            <p className='version'>Version 1</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Reservation